module.exports = __webpack_public_path__ + "static/media/G1246957_Japan-08.512ae313.png";